<template>
  <volcan-content class="details">
    <form class="detail" v-on:submit.prevent="update()">
      <volcan-card-layout :title="`Configurations`" icon="fas fa-file-invoice" :loading="loading">
        <volcan-card-tabs :data="tabs" />
        <volcan-alert :alert="alert" />
        <volcan-card-content v-if="item" class="tab-content"> 
          <div class="row">
            <volcan-input-text v-model="item.googleApiKey" text="Google Tag Manager Account ID" class="col-12" v-if="isAuthorizeSeo()" />
          </div>
        </volcan-card-content>
      </volcan-card-layout>

      <volcan-card-property>
        <volcan-card-layout title="Sauvegarde" icon="fa fa-save" class="save" :loading="loading">
          <volcan-card-content v-if="item">
            <i class="fa fa-clock-o" aria-hidden="true"></i>
            Version :
            <span class="time">{{item.versionName}}</span>
          </volcan-card-content>
          <div class="card-footer" v-if="item">
            <button type="submit" class="btn btn-primary">Sauvegarder</button>
          </div>
        </volcan-card-layout>
      </volcan-card-property>
    </form>

  </volcan-content>
</template>

<script>
import en from '../lang/admin-en.json'
import fr from '../lang/admin-fr.json'
import get from '@mixins/get.js'
import compte from '@mixins/compte.js'
export default {
  name: 'editsetting',
  mixins: [get, compte],
  data() {
    return {
      moduleName: 'setting',
      tabs: {
        languageIdActive: 0,
        content: {
          content: {
            title: 'Contenu',
            active: true,
            hasLanguage: false
          }
        }
      }
    }
  },
  beforeMount() {
    this.$i18n.add('fr', fr)
    this.$i18n.add('en', en)
  },
  methods: {
    update() {
      this.loading = true

      this.beforeUpdate()

      axios
        .put(`/api/${this.moduleName}/update/`, this.item)
        .then(response => {
          this.alert.success = true
          this.alert.message = this.$parseEsTemplate.parse(
            this.$t(`${this.moduleName}.itemModifiedMessage`),
            this
          )

          this.item = response.data.data

          this.updated()
          this.loading = false
        })
        .catch(error => {
          this.alert.success = false
          this.alert.message = this.manageErrorMessage(
            error.response.data.error
          )
          this.loading = false
        })
    },
    setUpdateMode() {
      this.updateMode = true
    },
    get() {
      var url = `/api/${this.moduleName}/get/`

      axios
        .get(url)
        .then(response => {
          this.item = response.data.data
          this.loading = false
          this.setTitleParameter(this.item)
        })
        .catch(error => {
          this.$router.push({
            name: `list${this.moduleName}`,
            params: {
              error: error.response.data.error.code
            }
          })
        })
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// helpers/setting/components/index.vue